import React from 'react';
import PropTypes from 'prop-types';
import Logo from 'src/components/Logo';
import { Box, IconButton, Link, Typography, useTheme } from '@mui/material';
import { withStyles } from '@mui/styles';
import { SidebarClose, SidebarOpen } from 'lucide-react';
import { blueGrey, grey } from '@mui/material/colors';
import { Link as RouterLink } from 'react-router-dom';

const StyledTypography = withStyles((theme) => ({
  root: { marginLeft: theme.spacing(1) }
}))(Typography);

const StyledIconButton = withStyles((theme) => ({
  root: {
    padding: '8px',
    backgroundColor: theme.palette.mode === 'light' ? grey[100] : blueGrey[900]
  }
}))(IconButton);
function NavBarHeader({
  drawerMode,
  showBoxShadow,
  toggleDrawer,
  ...otherProps
}) {
  const theme = useTheme();
  const shadow = showBoxShadow ? theme.shadows[4] : 'none';

  return (
    <Box
      p={2}
      pr={1}
      display="flex"
      alignItems="center"
      justifyContent={drawerMode === 'full' ? 'space-between' : 'center'}
      flexDirection={drawerMode === 'full' ? 'row' : 'column-reverse'}
      boxShadow={shadow}
      zIndex={1}
      sx={{
        transition: 'box-shadow 0.5s'
      }}
      {...otherProps}
    >
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        flexDirection={drawerMode === 'full' ? 'row' : 'column'}
      >
        {drawerMode === 'mini' && (
          <Box mb={1.5}>
            <StyledIconButton onClick={toggleDrawer}>
              <SidebarOpen size={20} />
            </StyledIconButton>
          </Box>
        )}
        <Box display="flex" alignItems="center" flexGrow={1}>
          <Link
            to="/app/home"
            component={RouterLink}
            color={theme.palette.mode === 'light' ? '#000' : '#fff'}
            sx={{
              lineHeight: 0.8,
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none'
            }}
          >
            <Logo width={45} />
            {drawerMode === 'full' && (
              <StyledTypography variant="h4">Bootstrapper</StyledTypography>
            )}
          </Link>
        </Box>

        {drawerMode === 'full' && (
          <StyledIconButton onClick={toggleDrawer}>
            <SidebarClose size={20} />
          </StyledIconButton>
        )}
      </Box>
    </Box>
  );
}

NavBarHeader.propTypes = {
  showBoxShadow: PropTypes.bool,
  drawerMode: PropTypes.string,
  toggleDrawer: PropTypes.func
};

export default NavBarHeader;
